import { render, staticRenderFns } from "./File.vue?vue&type=template&id=bd93162a&"
import script from "./File.vue?vue&type=script&lang=ts&"
export * from "./File.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports